import React, {useEffect, useState} from 'react';
import styled from 'styled-components';

import Welcome from '../components/CartoonitoParentalWelcome';
import Activites from '../components/CartoonitoParentalActivities';
import WaysToWatch from '../components/CartoonitoParentalWatch';
import {useDispatch, useSelector} from 'react-redux';
import {loadActivities} from '../store/actions/kidactivities';
import {selectKidsActivities} from '../store/reducers';
import ParentalMenu from '../components/CartoonitoParentalWelcome/ParentalMenu';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';

const CartoonitoParentalArea = props => {
    const dispatch = useDispatch();

    const [landscape, setLandscape] = useState(false);
    const {t} = useTranslation();

    useEffect(() => {
        dispatch(loadActivities());
    }, [dispatch]);

    useEffect(() => {
        handleWindowResize();

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
        // eslint-disable-next-line
    }, [landscape]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [landscape]);

    const handleWindowResize = () => {
        const windowWidth = window.innerWidth;
        if (landscape && windowWidth >= 600) {
            setLandscape(false);
        } else if (!landscape && windowWidth < 600) {
            setLandscape(true);
        }
    };

    let activities = useSelector(selectKidsActivities);

    return (
        <>
            <Helmet>
                <title>{t('parentalPage.metaTitle')}</title>
                <meta
                    name="description"
                    content={t('parentalPage.metaDescription')}
                />
            </Helmet>
            <Background>
                <Container>
                    <ParentalMenu />
                    <Welcome />
                    <Activites activities={activities} />
                    <WaysToWatch />
                </Container>
            </Background>
        </>
    );
};

const Background = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    background-color: white;
    align-items: center;
    max-width: 100%;
    overflow-x: hidden;
`;

const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;

    align-self: center;
    width: 100%;
    background-color: white;
`;

export default CartoonitoParentalArea;
